<template>
  <div class="my-header">
    <div class="logo">
      <img
        src="@/assets/home-logo.png"
        alt="logo"
      />
    </div>
    <div class="text">
      {{ title }}
    </div>
    <div class="link">
      <div class="link-info">
        <img
          src="@/assets/header-link.png"
          alt="home-link"
        />
        <span>{{ link }}</span>
      </div>
      <van-icon
        name="bars"
        size="30"
        color="#666"
        @click="handleClickShowMenu"
      />
    </div>
    <div class="navbar-popup">
      <van-popup
        v-model="showMenu"
        closeable
        position="right"
        close-icon="cross"
        close-icon-position="top-right"
        :style="{ width: '75%', height: '100vh' }"
      >
        <div class="nav-list">
          <div
            :class="item.key === currentMenu ? 'nav-item active' : 'nav-item'"
            v-for="item in navList"
            :key="item.key"
            @click="handleClickMenuItem(item)"
          >
            <span class="text">{{ item.name }}</span>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
  import { showA } from '@/utils/utils'
  import WalletState, { CHAIN_ID, MAX_INT } from '@/state/WalletState'
  export default {
    name: 'MyHeader',
    computed: {
      currentMenu() {
        return this.$route.path
      },
    },
    mounted() {
      WalletState.onStateChanged(this.handleAccountsChanged)
    },
    beforeDestroy() {
      WalletState.removeListener(this.handleAccountsChanged)
    },
    data() {
      return {
        title: 'OnePiece',
        link: '',
        showMenu: false,
        navList: [
          {
            key: '/',
            name: 'Home',
          },
          {
            key: '/medal',
            name: 'OnePiece Right Medal',
          },
          // {
          //   key: '/ok-lp',
          //   name: 'OK-LP',
          // },
          {
            key: '/ntf',
            name: 'OnePiece Community PFP',
          },

          // {
          //   key: '/unite',
          //   name: 'Unite',
          // },
          // {
          //   key: '/buy',
          //   name: 'buy',
          // },
          // {
          //   key: '/sell',
          //   name: 'sell',
          // },
          // {
          //   key: '/pay',
          //   name: 'pay',
          // },
          // {
          //   key: '/transfer',
          //   name: 'transfer',
          // },
        ],
      }
    },
    methods: {
      handleClickShowMenu() {
        this.showMenu = !this.showMenu
      },
      handleClickMenuItem(item) {
        if (this.$route.path !== item.key) {
          this.$router.push(item.key)
        }
        this.showMenu = false
      },
      handleAccountsChanged() {
        const wallet = WalletState.wallet
        this.chainId = wallet.chainId
        this.account = wallet.account
        this.link = showA(wallet.account)
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .my-header {
    width: 100%;
    height: 44px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    .logo {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: start;

      img {
        width: 24px;
        height: 24px;
      }
    }

    .text {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #17242b;
      font-size: 14px;
      font-weight: 500;
    }

    .link {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: end;
      align-items: center;
      column-gap: 8px;

      .link-info {
        width: 80px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        border: 1px solid #dfdfdf;
        background-color: #fff;

        img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }

        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #b1b1b1;
        }
      }
    }

    .navbar-popup {
      .nav-list {
        padding: 25% 12px 0;
        display: flex;
        flex-direction: column;
        row-gap: 12px;

        .nav-item {
          padding: 8px;
          border-bottom: 1px dashed #ccc;

          .text {
            font-size: 16px;
            color: #555;
            font-weight: bold;
          }
        }

        .nav-item.active {
          border-bottom: 1px dashed #3e8eb1;

          .text {
            color: #3e8eb1;
          }
        }
      }
    }
  }
</style>
